import React from 'react';
import {Box, Grid, Button} from '@material-ui/core';
import {TextField, FormControl, Stack, Snackbar, Alert, LinearProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {MetaTags} from 'react-meta-tags';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import Cookies from 'js-cookie';
import CheckIcon from '@mui/icons-material/Check';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText'; 
import TopicContentSave from './TopicContentSave';
import HideCourseTemplates from './HideCourseTemplates';
import DialogStudyContent from './DialogStudyContent';
import DialogAuthorization from '../components/DialogAuthorization';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';
import Header from "../pages/HeaderMy";
///import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  
  var vertical='top',horizontal='center';
  
  export default function Execute() { 
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isadminloggedin');
	const childRef = React.useRef();
	const childRefSave = React.useRef();
	const childRefCourseTemplates = React.useRef();
	const childRefAuthorization = React.useRef();
	const [showProgress, setShowProgress] = React.useState(false);
	const [pageLoading, setPageLoading] = React.useState(true);
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");	
	const [topicsList, setTopicsList] = React.useState([]);
	const [filterTopics, setFilterTopics] = React.useState("BIO");
	const [rows, setRows] = React.useState([]);
	const [templates, setTemplates] = React.useState([]);
	
	const [selectedIndex, setSelectedIndex] = React.useState(-1);
	const [contentObj, setContentObj] = React.useState({});
	
	const [topicName, setTopicName] = React.useState("");
	const [topicId, setTopicId] = React.useState(""); 
	const [templateId, setTemplateId] = React.useState(0);

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
	const [privileges, setPrivileges] = React.useState("");


	function hideAlert(){
		setShowAlert(false);
	}

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			window.location.href='login';
		}
	}, [isloggedin]);

	React.useEffect(() => {		
		if(userObj.loginId && userObj.token){
			getApiDataTopicList();
		}
	}, [userObj]);
	
	async function getApiDataTopicList(){		
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 
			setPageLoading(true);
			let endpoints1 = env.API_URL+"/topic-service/read/list?sortby=topicName";
			let endpoints2 = env.API_URL+"/exams/read/exam-templates?sortby=templateTitle";
			const axiosrequest1 = axios.get(endpoints1,axiosHeader);
			const axiosrequest2 = axios.get(endpoints2,axiosHeader);    
			await axios.all([axiosrequest1, axiosrequest2]).then(axios.spread(function(res1, res2) {
			  setPageLoading(false);
			  if(res1.data && res1.data.responseTxt==="success"){
				setTopicsList(res1?.data?.obj?.list);
				setPrivileges(res1?.data?.obj?.privileges);
			  }else if(res1.data && res1.data.responseTxt==="invalidToken"){ 
				Cookies.remove('isadminloggedin');
				window.location.href='login';
			  }else if(res1.data && res1.data.responseTxt==="NoAuthorization"){ 
				childRefAuthorization.current.handleClickOpen();
			  }  
			  
			  if(res2.data && res2.data.responseTxt==="success"){
				setTemplates(res2?.data?.obj?.list);
			  }

			}));
	  
	}

	React.useEffect(() => {		
		setRows([]);
		if(userObj.loginId && userObj.token){
			getApiDataContents();
		}
	}, [userObj,filter]);
	
	async function getApiDataContents(){		
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 
			setShowProgress(true);
			setPageLoading(true);
			axios.get(env.API_URL+"/exams/read/topic-contents?keyword="+keyword+"&topicId="+topicId+"&templateId="+templateId, axiosHeader) 
			   .then(response => {
				 setPageLoading(false); 
				 setShowProgress(false);
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="success" && response.data.list.length>0){
					setRows(response.data.obj.list);
				}		
			})	
	}

	function deleteData(){
		if(contentObj && contentObj.autoId>0 && userObj.loginId && userObj.token){
			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'
				}
			}; 

		  const data = new FormData();
		  data.append('id', contentObj.autoId);
		  data.append('topicId', contentObj.topicId);
				 
		  axios.post(env.API_URL+'/exams/delete/topic-contents', data, axiosHeader)
				.then((response) => {
					deleteDialogHide();
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Content has been deleted.");
					setRows(response.data?.obj?.list);
					setContentObj({});	
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This content could not be deleted.");			
					return false;
				}
			}).catch((error) => {
					console.log("AXIOS ERROR: ", error);
				})


		}		
	
		
	}

	function saveData(opt){
		if(opt===1){
			setContentObj({});
		}	
		childRefSave.current.handleClickOpen();
	}

	// function selectRow(obj){
	// 	if(obj && rows[obj.id-1]){			
	// 		setSelectedRow(rows[obj.id-1].id);
	// 		setDataObj(rows[obj.id-1]);
	// 		///childRef.current.handleClickOpen();
	// 	}
	// }

	const handleListItemClick = (event, index, obj) => {
		setSelectedIndex(index);
		setTopicName(obj.topicName);
		setTopicId(obj.autoId);
		setFilter(!filter);
	};

	function search(){
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}
	
	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function updatedList(list) {
		setRows(list);
	}

	function confirmDelete(myObj){
		setContentObj(myObj);
		setDeleteDialogShow(true);
	}

	function editData(myObj){
		setContentObj(myObj);
		childRefSave.current.handleClickOpen();
	}

	function courseTemplates(myObj){
		setContentObj(myObj);
		childRefCourseTemplates.current.handleClickOpen();
	}
	
	function exeContent(obj){ 
		if(obj && obj.contentType==='Video'){
			setContentObj(obj);
			childRef.current.handleClickOpen();	
		}else{
			if(window.screen.width<480){
				window.open(obj.contentUrl, "_blank");
			}else{
				setContentObj(obj);
				childRef.current.handleClickOpen();
			}
		}	
	}

	function handleFilterTopics(val){
		setFilterTopics(val);
	}	

	function handleTemplate(tid){
		setTemplateId(tid);
		setFilter(!filter);
	}

	return (
		<div> 
				<MetaTags>
            		<title>Smart Learning</title>
          		</MetaTags>
				
				<Header title='Smart Learning' />
				{pageLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

					<Box mt={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12} style={{marginBottom:15}} className='btmbdrgry'>
									<FormControl style={{float:'left',width:250,marginRight:6}} >
										<InputLabel id="source-select-label">Template</InputLabel>
										<Select 
											label="Template"
											style={{width:'99%'}}
											labelId="source-select-label"
											id="select-class"
											size="small"
											value={templateId}									
											onChange={event => handleTemplate(event.target.value)}                                  
											>
												<MenuItem value={0}>{templateId>0?<>Unselect</>:<>Select</>} Template</MenuItem>
												{templates?templates.map((myRow,mykey)=>(
												<MenuItem key={'cntyp'+mykey} value={myRow.autoId}>{myRow.templateTitle}</MenuItem>
												)):null}
										</Select>
									</FormControl>
									<FormControl style={{float:'left',width:150,marginRight:60}}>
										<TextField
										id="keywordtxt"
										label="Search Content"
										defaultValue={keyword}
										sx={{ width: 200 }}
										size="small"
										onChange={event => setKeyword(event.target.value)}
										onKeyPress={(event)=>{onEnter(event)}}
										/>
									</FormControl>

									<Button onClick={() => {search()}} style={{float:'left', marginTop: 3}} size="small" variant="contained" color="secondary" >Search</Button>

									<div style={{float:'left', marginTop: 5}}>	
										{(privileges && privileges.length>0 && privileges.indexOf("create")>-1)?
											<i onClick={()=>{saveData(1)}}  rel='noopener' title="Add New" className="fa fa-plus-circle" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
										:null}										
									</div>

								</Grid>
							</Grid>
					</Box>

					<Box >
						<Grid container spacing={2}>
								<Grid item md={3} xs={12} style={{borderRight:'1px solid #000'}} >
									<div style={{height:'75vh'}}>
									<TextField onChange={event => handleFilterTopics(event.target.value)} value={filterTopics} placeholder={'Filter Topics'} fullWidth size="small" variant="outlined" />
									<List component="nav" style={{maxHeight: '65vh', overflow: 'auto'}} aria-label="secondary mailbox folder">
									{(topicsList && topicsList.length>0)?topicsList.filter(obj => obj.topicName.toLowerCase().startsWith(filterTopics.toLowerCase())).map((row,i)=>(
										<ListItemButton
										selected={selectedIndex === i}
										onClick={(event) => handleListItemClick(event, i, row)}
										key={'t'+i}
										>
											{selectedIndex === i?
											<ListItemIcon>
												<CheckIcon />
											</ListItemIcon>
											:null}  
											<ListItemText primary={row.topicName} />
										</ListItemButton>
									)):null}                      
									</List> 
									</div>
								</Grid>
								<Grid item md={9} xs={12}>
									<Box  mt={3} >
									{topicName?<div style={{fontWeight:'bold',marginBottom:40,marginTop:-20}}>Selected Topic: {topicName}</div>:null}
									<Grid container spacing={2} className="materialBox" >
										{rows.length?rows.map((myRow,index)=>(
											<Grid key={'mtldd'+index} item style={{marginTop:2}} >
												<div className='contOrder' >{myRow.sequence}</div>
												<div className="smitem" onClick={()=>{exeContent(myRow)}} >													
												<p>
													{myRow.contentType==='Video'?<i className="fa fa-play-circle"></i>:myRow.contentType==='PDF'?<i className="fa fa-file-pdf-o"></i>:myRow.contentType==='PPT'?<i className="fa fa-file-powerpoint-o"></i>:<i className="fa fa-globe"></i>}												
												</p>
												<p className="text-line-2">
													{myRow.contentName}
												</p>	
												</div>
												<div className='actionBtnBox'>
													<span style={{marginRight:10,fontSize:'smaller'}}>{myRow.language}</span>
													{myRow.hidden===1?
														<i className="fa fa-eye-slash" title="Hidden" style={{fontSize:15, color:'#888888',marginRight:10}} />
													:	
														<i className="fa fa-eye" title="Display" style={{fontSize:15, color:'#888888',marginRight:10}} />
  													}	
													{(privileges && privileges.length>0 && privileges.indexOf("delete")>-1)?
														<i onClick={()=>{confirmDelete(myRow)}} title="Delete" className="fa fa-trash" style={{fontSize:15, color:'#888888',marginRight:10, cursor:'pointer'}} />
													:null}													
													{(privileges && privileges.length>0 && privileges.indexOf("update")>-1)?<>
														<i onClick={()=>{editData(myRow)}} title="Edit" className="fa fa-pencil-square-o" style={{fontSize:15, color:'#888888',marginRight:10, cursor:'pointer'}} />
														<i onClick={()=>{courseTemplates(myRow)}} title="Course Templates" className="fa fa-list" style={{fontSize:15, color:'#888888',marginRight:10, cursor:'pointer'}} />
													</>:null}													
												</div>
											</Grid>
										)):showProgress?<div style={{textAlign:'center',width:'100%'}} ><CircularProgress /><br/>Loading...</div>:(topicId && topicId>0) || (keyword && keyword.length>0)?<div style={{color:'#FF0000',fontSize:14,fontWeight:'bold',textAlign:'center',width:'100%'}}>Data not found</div>:<div style={{color:'#0000FF',fontSize:14,fontWeight:'bold',textAlign:'center',width:'100%'}}>Select topic from left panel</div>}	
									</Grid>
									</Box>
								</Grid>
							</Grid>

					</Box>

				</Box>

			<TopicContentSave dataObj={contentObj} topicId={topicId} topicName={topicName} updatedList={updatedList} topicsList={topicsList} ref={childRefSave} />						
			<HideCourseTemplates dataObj={contentObj} ref={childRefCourseTemplates} />

			<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
			</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

				<DialogAuthorization ref={childRefAuthorization} />
				<DialogStudyContent contentObj={contentObj} ref={childRef} />
		</div>	
	);
  }